export const DEFAULT_TITLE = 'Bitbucket';
export const TITLE_TEMPLATE = '%s — Bitbucket';
